import React from 'react';

const DonutIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 20 20">
            <g id="layer1">
            <path 
                d="M 10 0 A 10 10 0 0 0 0 10 A 10 10 0 0 0 10 20 A 10 10 0 0 0 20 10 A 10 10 0 0 0 10 0 z M 10 1 A 9 9 0 0 1 13.755859 1.8320312 L 12.351562 4.4882812 A 6 6 0 0 0 10 4 A 6 6 0 0 0 4 10 A 6 6 0 0 0 4.1308594 11.234375 L 1.2578125 12.095703 A 9 9 0 0 1 1 10 A 9 9 0 0 1 10 1 z M 14.640625 2.3007812 A 9 9 0 0 1 17.271484 4.7148438 L 14.748047 6.3417969 A 6 6 0 0 0 13.238281 4.9492188 L 14.640625 2.3007812 z M 10 5 A 5 5 0 0 1 15 10 A 5 5 0 0 1 10 15 A 5 5 0 0 1 5 10 A 5 5 0 0 1 10 5 z M 17.8125 5.5546875 A 9 9 0 0 1 19 10 A 9 9 0 0 1 18.939453 11.005859 L 15.974609 10.503906 A 6 6 0 0 0 16 10 A 6 6 0 0 0 15.292969 7.1796875 L 17.8125 5.5546875 z M 15.806641 11.490234 L 18.767578 11.992188 A 9 9 0 0 1 13.015625 18.470703 L 12.167969 15.587891 A 6 6 0 0 0 15.806641 11.490234 z M 4.421875 12.191406 A 6 6 0 0 0 10 16 A 6 6 0 0 0 11.208984 15.876953 L 12.056641 18.75 A 9 9 0 0 1 10 19 A 9 9 0 0 1 1.5429688 13.054688 L 4.421875 12.191406 z " 
                style={{ fill: "#222222", fillOpacity: 1, stroke: "none", strokeWidth: "0px" }}
            />
            </g>
        </svg>
    )
}

export default DonutIcon;